'use client';

import React, { PropsWithChildren } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, Stack, TextField, MenuItem, Typography } from '@mui/material';

import { icons } from '@peerless/ui-assets/icons';
import { CopyBlock } from './CopyBlock';

import TradeShowBg from '@peerless/ui-assets/images/LED_Video_Wall_Application_Image_Campus.jpg';
import { useTranslations } from 'next-intl';

const textFieldStyles = {
  color: 'common.white',
  borderColor: 'common.white',
  '& .MuiInputBase-root': {
    color: 'common.white',

    '&:before, &:after': {
      borderColor: 'common.white',
    },
  },

  '& .MuiInputLabel-root, & .MuiInput-input': {
    color: 'common.white',

    '&.Mui-focused': {
      color: 'common.white',
    },
  },
};

export const StayConnectedFormSection: React.FC<PropsWithChildren> = ({ children }) => {
  const t = useTranslations();
  return (
    <Stack sx={{ backgroundImage: 'url(' + TradeShowBg.src + ')' }}>
      <Box
        sx={{
          backgroundColor: 'transparent.blue',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          color: '#fff',
          padding: '2rem',
          '& h4': {
            position: 'relative',
            marginBottom: '1.5rem',
            '&:after': {
              backgroundColor: 'primary.contrastText',
            },
          },
          '& .viewMore': {
            color: 'primary.red',
            fontSize: '.5rem',
            textAlign: 'center',
            textTransform: 'uppercase',
            fontWeight: '700!important',
          },
        }}
      >
        <CopyBlock
          title={'Stay Connected'}
          copy={
            'Want to receive the latest in product news, tips and tools? Sign up below and stay connected to an industry leader!'
          }
        ></CopyBlock>
        <Grid container sx={{ maxWidth: '800px;' }} spacing={2}>
          <Grid item xs={6}>
            <TextField label="First Name" variant="standard" sx={textFieldStyles} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Last Name" variant="standard" sx={textFieldStyles} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Email Address" variant="standard" sx={textFieldStyles} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Job Title" variant="standard" sx={textFieldStyles} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Company" variant="standard" sx={textFieldStyles} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Country"
              variant="standard"
              select
              defaultValue=""
              SelectProps={{
                IconComponent: SelectIcon,
              }}
              sx={textFieldStyles}
            >
              <MenuItem value="" color="secondary.gray">
                <Typography color="grey.500" component="span">
                  {t('Social.select-country')}
                </Typography>
              </MenuItem>
              <MenuItem value="United States">{t('Social.country')}</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

export function SelectIcon() {
  return (
    <FontAwesomeIcon
      icon={icons.down}
      style={{
        position: 'absolute',
        right: 6,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    />
  );
}
